/*
 * Copyright (c) 2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import DisplayIcon from "./Icons/DisplayIcon.jsx";

export const SidebarNavItem = ({
                                   onClick,
                                   ownId,
                                   onMiddleMouseClick,
                                   isMultiSelected,
                                   isOpen,
                                   iconName,
                                   text,
                                   status
                               }) => {
    return (
        <div onClick={onClick} key={ownId} onMouseDown={(event) => {
            // on middle mouse click
            if (event.button === 1) {
                // open website in new window
                onMiddleMouseClick()
            }
        }}
             className={`flex items-center group h-11 pl-2 text-sm font-normal rounded-md no-underline ${isOpen ? ("text-blue-700  border shadow border-blue-400  cursor-pointer") : ("text-black hover:bg-stone-50 hover:text-gray-900  border cursor-pointer")}`}>
            <DisplayIcon iconName={iconName} size={"1.5em"}
                         className={"text-gray-600 group-hover:text-gray-500 shrink-0"}/>

            <span className="ml-2 mr-2 truncate select-none grow">  {text} </span>
            {isMultiSelected ? (<>
                <div className={"mx-2"}>
                    <DisplayIcon iconName={"PiCheck"} size={"1.5em"}
                                 className={"text-blue-600 group-hover:text-gray-500 shrink-0"}/>
                </div>
            </>) : (<>
          <span
              className="   ml-auto p-2  font-medium rounded-r-md  items-center justify-center  flex">
                {status}
            </span>
            </>)}

        </div>
    )
}